import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=9c7d2556&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=9c7d2556&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7d2556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c7d2556')) {
      api.createRecord('9c7d2556', component.options)
    } else {
      api.reload('9c7d2556', component.options)
    }
    module.hot.accept("./Course.vue?vue&type=template&id=9c7d2556&scoped=true", function () {
      api.rerender('9c7d2556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Course.vue"
export default component.exports